import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const CalendarEdit = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.66667 13.3333H0.666667V2.66666H14V7.33333"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M3.33333 2.66667V0"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M11.3333 2.66667V0"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M0.666667 6H14"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M8.66667 16H10.6667L16 10.6667L14 8.66666L8.66667 14V16Z"
      fill="currentColor"
    />
  </svg>,
  'CalendarEdit'
);
